var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { height: "55px", flat: "" } },
    [
      _c(
        "v-bottom-nav",
        {
          attrs: {
            active: _vm.pasoActivoIndex,
            value: true,
            absolute: "",
            color: "transparent"
          },
          on: {
            "update:active": function($event) {
              _vm.pasoActivoIndex = $event
            }
          }
        },
        [
          _c(
            "v-layout",
            { attrs: { "justify-center": "" } },
            _vm._l(Object.values(_vm.pasos), function(paso) {
              return _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: paso.visible,
                      expression: "paso.visible"
                    }
                  ],
                  key: paso.step,
                  attrs: { color: "primary", flat: "", value: paso.step },
                  on: { click: _vm.handleStepClick }
                },
                [
                  _c("span", [_vm._v(_vm._s(paso.title))]),
                  _c("v-icon", [_vm._v(_vm._s(paso.icon))])
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }